import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { LogService } from "../../services/log.service";
import { SharedService } from "../../services/shared.service";
import { TAGS } from "../../models/constants";
import { ToastrService } from "ngx-toastr";
import {
  CacheNamesEnum,
  Constants,
  CUSTOM_SORT,
  EvaluationFlowsEnum,
  LogLine,
  UserDTO
} from "../../models/shared.model";
import moment from "moment/moment";
import { TranslateService } from "@ngx-translate/core";
import {
  ConfirmationDialogComponent,
  ConfirmationDialogData
} from "../settings/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-logs",
  templateUrl: "./logs.component.html",
  styleUrl: "./logs.component.css"
})
export class LogsComponent implements OnChanges{
  @Input("logsArr") logsArr: LogLine[];
  logsMap: Map<string, LogLine[]> = new Map();

  uploadingLog = false
  user: UserDTO;
  disableUploadBtn = true
  constructor(
    protected logService: LogService,
    public dialog: MatDialog,
    protected sharedService: SharedService,
    private toastrService: ToastrService,
    private translate: TranslateService
  ) {
    this.user = JSON.parse(window.localStorage.getItem(CacheNamesEnum.USER)!) as UserDTO;

    const now = moment.utc()
    const uploadExpirationDate = moment.utc(this.user?.upload_expiration_date)

    if(uploadExpirationDate && uploadExpirationDate.isAfter(now))
      this.disableUploadBtn = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["logsArr"]?.currentValue && changes["logsArr"]?.previousValue) {
      if (JSON.stringify(changes["logsArr"].currentValue) != JSON.stringify(changes["logsArr"].previousValue)) {
        this.logsArr = changes["logsArr"]?.currentValue;
        this.processLogs();
      }
    }
    else if (changes["logsArr"].previousValue == null) {
      this.logsArr = changes["logsArr"]?.currentValue;
      this.processLogs();
    }
  }

  includeEmailAndLinksCheckDialog(upload: boolean) {
    const dialogData: ConfirmationDialogData = {
      message: this.translate.instant("logs.include_info_confirmation"),
      confirmBtnText: this.translate.instant("shared.yes"),
      cancelBtnText: this.translate.instant("shared.no")
    };

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(value => {
      if(value != undefined)
        this.handleLogFile(upload, value)
    })
  }

  protected async handleLogFile(upload: boolean, includeEmailAndLinks: boolean) {
    const {data, fileName} = this.logService.generateLogFileAndName(includeEmailAndLinks);

    if (upload)
      await this.uploadLog(data, fileName);
    else
      this.downloadLog(data, fileName);

  }

  private downloadLog(data: string, fileName: string) {
    const newBlob = new Blob([data], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(newBlob);
    const link = document.createElement(TAGS.LINK);
    link.href = url;
    link.download = fileName;

    link.click();
    this.toastrService.success(this.translate.instant('logs.log_file_downloaded_successfully'));
  }

  private async uploadLog(data: string, fileName: string) {
    this.uploadingLog = true
    await this.sharedService.uploadLogFile(data, "text/plain", fileName)
      .then(value => {
        if (value)
          this.toastrService.success(this.translate.instant('logs.log_file_uploaded_successfully'));
        else
          this.toastrService.error(this.translate.instant('logs.failed_to_upload_log_file'));
      })
      .finally(() => this.uploadingLog = false);
  }


  processLogs() {
    this.logsMap = new Map<string, LogLine[]>();
    for (const item of this.logsArr) {
      const group = this.logsMap.get(item.flow);
      if (group) {
        group.push(item);
      } else {
        this.logsMap.set(item.flow, [item]);
      }
    }

    this.sort();
  }

  sort(){
    const sortedEntries = Array.from(this.logsMap?.entries()).sort(([keyA], [keyB]) => {
      const indexA = CUSTOM_SORT.indexOf(keyA as EvaluationFlowsEnum | Constants);
      const indexB = CUSTOM_SORT.indexOf(keyB as EvaluationFlowsEnum | Constants);

      return indexA - indexB;
    });

    this.logsMap = new Map<string, LogLine[]>(sortedEntries);
  }

  asIsOrder(a, b) {
    return 1;
  }
}
